module.exports = __webpack_public_path__ + "assets/img/skinx-1.f0b471f4.png";